const KEY = "perfero_cookie_consent";
const MAX_AGE_MS = 182 * 24 * 60 * 60 * 1000;
export const OPEN_PREFERENCES_EVENT = "perfero:cookie-preferences";

export const readConsent = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!saved || typeof saved.analytics !== "boolean") return null;
    if (Date.now() - new Date(saved.date).getTime() > MAX_AGE_MS) return null;
    return saved;
  } catch {
    return null;
  }
};

export const saveConsent = (analytics) => {
  localStorage.setItem(KEY, JSON.stringify({ analytics, date: new Date().toISOString() }));
  if (analytics) {
    if (window.__analyticsStarted) window.posthog?.opt_in_capturing?.();
    else window.__startAnalytics?.();
  } else if (window.__analyticsStarted) {
    window.posthog?.opt_out_capturing?.();
  }
};

export const openCookiePreferences = () => window.dispatchEvent(new Event(OPEN_PREFERENCES_EVENT));
